<div class="container">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        Import Abfallkalender-Daten
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-expansion-panel expanded="true">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        Wie muss die Tabelle aufgebaut sein?
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <ol>
                                    <li>Straßenname (Street)</li>
                                    <li>Müllart (Type): "BIO", "YELLOW", "RESIDUAL", "PAPER" und "BULKY" werden
                                        unterstützt</li>
                                    <li>Datum (Date): Im Format "dd.MM.yyyy" zum Beispiel: 17.06.2018</li>
                                </ol>
                            </mat-expansion-panel>


                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        Warum werden die hochgeladenen Daten falsch angezeigt?
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <ul>
                                    <li>Sie haben versehentlich eine falsche Datei hochgeladen.
                                    </li>
                                    <li>Umlaute (ä,à,ô,ß) werden nicht korrekt angezeigt, ändern Sie bitte das
                                        Encoding der Kundendatei auf UTF-8 (ohne BOM).
                                        Bei Problemen das Encoding zu ändern, nutzen Sie beispielsweise
                                        <a target="_blank" href="https://notepad-plus-plus.org/">Notepad++</a>
                                        <br>
                                        <img [src]="encodingImageLink">
                                    </li>
                                    <li>Die Spaltenanzahl ist nicht genau 3 und daher nicht korrekt.</li>
                                    <li>Bitte vermeiden Sie die Verwednung des Kommas innerhalb der Felder, da dies als
                                        Trennzeichen fungiert.</li>
                                    <li>Es wurde als CSV-Trenner kein Komma verwendet.</li>
                                    <li>Das Datum wurde nicht im Format "dd.MM.yyyy" angegeben.</li>
                                </ul>
                            </mat-expansion-panel>

                        </div>

                    </div>

                    <div class="row">
                        <div class="col-sm-12 marginTop2Rem marginBottom2Rem">
                            <div ngx-dropzone [accept]="'*'" [multiple]="false" (change)="onSelect($event)">
                                <ngx-dropzone-label>
                                    <div>
                                        <h3>CSV-Datei hierher ziehen</h3>
                                        <h5>ODER</h5>
                                        <button mat-raised-button color="accent">Durchsuchen</button>
                                    </div>
                                </ngx-dropzone-label>
                                <ngx-dropzone-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files"
                                    [file]="f" [removable]="true" (removed)="onRemove(f)">
                                    <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                                </ngx-dropzone-preview>
                            </div>
                        </div>
                    </div>

                    <div class="row  marginBottom2Rem">
                        <div class="col-sm-12">
                            <mat-table [dataSource]="previewData" class="mat-elevation-z2" *ngIf="previewData">
                                <ng-container [matColumnDef]="col.field" *ngFor="let col of columnDefs">
                                    <mat-header-cell *matHeaderCellDef>{{ col.name }}</mat-header-cell>
                                    <mat-cell *matCellDef="let element">{{ element[col.field] }}</mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="garbageColumns"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: garbageColumns;"></mat-row>
                            </mat-table>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end" >
                    <button mat-button color="primary" (click)="movebacktoOverview()"> Abbrechen</button>
                    <button mat-button color="primary" (click)="startImport()" [disabled]="this.files.length == 0"> Import starten</button>
                </mat-card-actions>
            </mat-card>

        </div>
    </div>

</div>